// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const gl = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Inicio',
    search: 'Buscar',
    login: 'Iniciar sesión',
    register: 'Rexistrarse',
    dashboard: 'Resumo',
    reservas: 'Reservas',
    equipo: 'Equipo',
    logout: 'Pechar sesión',
    legal: 'Legal',
    legalNotice: 'Aviso legal',
    privacy: 'Política de privacidade',
    cookies: 'Política de cookies',
    terms: 'Termos e condicións',
    clientes: 'Clientes',
  },
  legal: {
    noticeTitle: 'Aviso legal',
    noticeBody:
      'En cumprimento da Lei 34/2002 (LSSI-CE), infórmase de que este sitio web é titularidade de bitutravel. Correo de contacto: legal@bitutravel.app. O uso do sitio atribúe a condición de usuario e implica a aceptación destas condicións.',
    privacyTitle: 'Política de privacidade',
    privacyBody:
      'Tratamos os teus datos unicamente para xestionar a túa conta, as túas reservas e a facturación exixida pola normativa española (RXPD e LOPDGDD). Nunca cedemos os teus datos a terceiros con fins comerciais. Podes exercer os teus dereitos de acceso, rectificación, supresión e portabilidade escribindo a privacy@bitutravel.app.',
    cookiesTitle: 'Política de cookies',
    cookiesBody:
      'bitutravel utiliza só cookies técnicas imprescindibles: a sesión de autenticación e a preferencia de idioma. Non usamos cookies publicitarias nin de seguimento de terceiros.',
    termsTitle: 'Termos e condicións',
    termsBody:
      'As reservas solicítanse a través da plataforma e quedan suxeitas á aprobación do propietario e á política de cancelación elixida. A facturación corporativa emítese conforme á normativa española (IVE e IRPF aplicables). bitutravel actúa como intermediario entre a empresa solicitante e o propietario do aloxamento. Os prezos mostrados non inclúen IVE (21%), que se engade ao total da reserva.',
  },
  landing: {
    heroTitle: 'Aloxamento corporativo sen complicacións',
    heroSubtitle:
      'Atopa aloxamento de calidade a medio prazo para os teus equipos en toda España. Coa confianza de empresas líderes.',
    checkIn: 'Entrada',
    checkOut: 'Saída',
    guests: 'Hóspedes',
    search: 'Buscar',
    featured: 'Estancias destacadas',
    featuredIn: 'Destacados en {{city}}',
    guestsValue: '{{count}} hóspedes',
    where: 'Onde',
    when: 'Cando',
    who: 'Quen',
    searchDestinations: 'Buscar destinos',
    addDates: 'Engadir datas',
    addGuests: 'Engadir hóspedes',
    howItWorks: 'Como funciona',
    step1Title: 'Busca',
    step1Desc: 'Explora aloxamentos verificados nas principais cidades de España.',
    step2Title: 'Reserva',
    step2Desc: 'Reserva estancias de media duración para os teus equipos con condicións corporativas.',
    step3Title: 'Mudate',
    step3Desc: 'O teu equipo aloxarase. Nós xestionamos a factura e o parte de viaxeiro.',
    perNight: '/ noite',
    perNightPlusIva: '/ noite + IVE',
    comingSoon: 'Proximamente',
    trustedBy: 'Xa confían en nós',
    testimonialsTitle: 'O que din os nosos clientes',
    review1Text: 'Desde que uso bitutravel chéganme as facturas e simplifica todo o proceso.',
    review1Author: 'María López',
    review1Role: 'Responsábel de mobilidade, consultora tecnolóxica',
    review2Text: 'Xestionamos o aloxamento de todo o equipo nunha soa plataforma. O aforro en tempo e custos é evidente.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Director de operacións, empresa de enxeñería',
    review3Text: 'A facturación corporativa e a nota de viaxeiro veñen listas para auditoría. Cero traballo administrativo.',
    review3Author: 'Elena García',
    review3Role: 'Responsábel financeira, multinacional',
    illustrativeImage: 'imaxe ilustrativa',
  },
  search: {
    allSpain: 'Toda España',
    allDistricts: 'Todos os distritos',
    viewAllResults: 'Ver todos os resultados',
    results: 'resultados',
    sort: 'Ordenar',
    sortPriceAsc: 'Prezo: de menor a maior',
    sortPriceDesc: 'Prezo: de maior a menor',
    noResults: 'Non hai aloxamentos nesta zona.',
    noResultsForFilters: 'Non hai aloxamentos para estes filtros. Proba a quitar datas ou cambiar os filtros.',
    clearFilters: 'Quitar filtros',
    areaPlaceholder: 'Barrio, zona ou código postal',
    showMap: 'Mapa',
    showMore: 'Ver máis',
    backToTop: 'Volver arriba',
    typeAll: 'Todo',
    placeEntire: 'Apartamento enteiro',
    placeRoom: 'Habitación',
    placeHotel: 'Hotel',
    dates: 'Datas',
    sortRecommended: 'Recomendado',
    size: 'Dormitorios',
    sizeAny: 'Calquera',
    sizeSingle: '1 dormitorio',
    sizeDouble: '2 dormitorios',
    size3plus: '3+ dormitorios',
    rooms: 'Dormitorios',
    units: 'Unidades',
    grouping: 'Agrupar',
    groupAny: 'Calquera',
    typeInCity: '{{type}} en {{city}}',
    forNights: 'por {{count}} noites',
    filters: 'Filtros',
    groupSameBuilding: 'Mesmo edificio',
    groupSameArea: 'Zona próxima',
    groupSameCategory: 'Mesma categoría',
    roomsValue: '{{count}} hab.',
    unitsValue: '{{count}} uds.',
    groupResults: 'grupos',
    fromPrice: 'desde {{price}}',
    unitsInBuilding: '{{count}} unidades neste edificio',
    groupUnits: 'unidades',
    sameBuilding: 'Mesmo edificio',
    sameArea: 'Zona próxima',
    sameCategory: 'Mesma categoría',
    anyGroup: 'Unidades',
    priceFrom: 'desde',
    bookAll: 'Reservar as {{count}}',
    playTour: 'Reproducir percorrido',
    approxMapNote: 'As localizacións son aproximadas. Rexístrate para ver a localización exacta.',
    pauseTour: 'Pausar percorrido',
    bookAllTitle: 'Reservar o grupo',
    bookAllDesc: 'Reserva as {{count}} unidades como un mesmo conxunto.',
    bookAllSummary: '{{count}} unidades · {{nights}} noites',
    bookAllSomeFailed: 'Algunhas unidades non se puideron reservar.',
    bookAllDone: 'Conxunto reservado ({{ok}}/{{count}}).',
    structRoomIn: 'Habitación en {{building}}',
    structRoomsSameApartment: '{{count}} habitacións no mesmo apartamento',
    structRoomsSameBuilding: '{{count}} habitacións no mesmo edificio',
    structApartmentsSameBuilding: '{{count}} apartamentos no mesmo edificio',
    structStaysSameArea: '{{count}} aloxamentos na mesma zona',
    structStaysSameCategory: '{{count}} aloxamentos · {{category}}',
    structUnits: '{{count}} unidades',
    specFull: '{{guests}} hóspedes · {{bedrooms}} dormitorios · {{baths}} baños',
    specShort: '{{bedrooms}} dorm. · {{baths}} baño',
  },
  detail: {
    guests: 'hóspedes',
    bedrooms: 'dormitorios',
    bathrooms: 'baños',
    amenities: 'Servizos',
    location: 'Localización',
    nights: 'noites',
    cleaningFee: 'Limpeza',
    total: 'Total',
    iva: 'IVE ({{pct}}%)',
    ivaNote: 'Prezos sen IVE: engádese o 21% de IVE ao total da reserva. Factura corporativa conforme.',
    bookNow: 'Reservar agora',
    loginToBook: 'Inicia sesión para reservar',
    signInForDetails: 'Inicia sesión para ver os detalles completos.',
    approxLocation: 'Localización aproximada (raio de ~700 m)',
    checkin: 'Entrada',
    checkout: 'Saída',
    tooManyGuests: 'Esta propiedade admite ata {{capacity}} hóspedes.',
    minStayWarning: 'Estancia mínima: {{count}} noite | Estancia mínima: {{count}} noites',
    nightsWithCount: '{{count}} noite | {{count}} noites',
  },
  booking: {
    title: 'Reservar agora',
    subtitle: 'Verifica os datos do viaxeiro. O importe recalculase no servidor.',
    confirm: 'Confirmar reserva',
    guestName: 'Nome do viaxeiro',
    guestNamePlaceholder: 'Nome e apelidos',
    guestNif: 'NIF do viaxeiro',
    datesRequired: 'Selecciona datas válidas',
    nameRequired: 'Introduce o nome do viaxeiro',
    nifInvalid: 'NIF non válido',
    requestCreated: 'Reserva creada. Pendente de pagamento.',
    notAvailable: 'Esas datas xa non están dispoñibles.',
    notApproved: 'A túa conta non está aprobada para reservar.',
    createError: 'Non se puido crear a reserva. Téntao de novo.',
    awaitingDesc: 'Reserva creada. Realiza o pagamento para confirmala.',
    totalWithIva: 'Total (IVE incluído)',
    priceEstimateNote: 'Prezo estimado: bitutravel calcula o importe final ao reservar.',
    total: 'Total',
    reference: 'Referencia',
    openPaymentLink: 'Abrir o enlace de pagamento',
    mockDevNote:
      'Modo desenvolvemento: o pagamento é simulado. Preme para marcalo como pagado e simular o webhook de Revolut.',
    markPaidDev: 'Marcar como pagado (dev)',
    markPaidError: 'Non se puido simular o pagamento.',
    paid: 'Pagamento confirmado',
    paidDesc: 'A túa reserva está confirmada. Recibirás a factura por correo.',
    viewBookings: 'Ver as miñas reservas',
    paymentStatus: 'Pagamento',
    bookingsTitle: 'As miñas reservas',
    browseStays: 'Buscar aloxamento',
    summaryTotal: 'Reservas',
    summaryUpcoming: 'Próximas',
    summaryInstay: 'En estancia',
    summarySpend: 'Gasto total',
    summaryPendingNote: 'Tes {{count}} reservas pendentes de pagamento.',
    payStatusPaid: 'Pagado',
    payStatusPending: 'Pendente',
    payStatusAwaiting: 'Pendente de pagamento',
    payStatusRefunded: 'Reembolsado',
    payStatusFailed: 'Fallido',
    payStatusScheduled: 'Programado',
    empty: 'Aínda non tes reservas.',
    statusAwaitingPayment: 'Pendente de pagamento',
    statusConfirmed: 'Confirmada',
    statusActive: 'En curso',
    statusCompleted: 'Completada',
    statusCancelled: 'Cancelada',
    statusDisputed: 'En disputa',
    notFound: 'Reserva non atopada.',
    viewProperty: 'Ver a propiedade',
    cleaningFee: 'Limpeza',
    platformFee: 'Comisión de bitutravel',
    cancelBooking: 'Cancelar a reserva',
    cancelConfirm: 'Seguro que queres cancelar esta reserva? Esta acción non se pode desfacer.',
    cancelConfirmYes: 'Si, cancelar',
    cancelledToast: 'Reserva cancelada.',
    cancelError: 'Non se puido cancelar a reserva.',
    cancelReason: 'Motivo da cancelación',
    copyLink: 'Copiar o enlace',
    tabFuture: 'Próximas',
    tabPresent: 'En curso',
    tabPast: 'Pasadas',
    emptyTab: 'Non hai reservas nesta sección.',
    purpose: 'Motivo da viaxe',
    purposeLeisure: 'Persoal',
    purposeConference: 'Congreso / evento',
    purposeProject: 'Proxecto',
    purposeRelocation: 'Reubicación',
    purposeOther: 'Outro',
    eventName: 'Nome do evento',
    eventNamePlaceholder: 'ex. Mobile World Congress 2026',
    teamSize: 'Persoas',
    teamNotes: 'Detalles do equipo',
    teamNotesPlaceholder: 'Nomes dos viaxeiros, cuarto, notas…',
    teamDetails: 'Detalles da viaxe / equipo',
    employee: 'Empregado',
    employeePlaceholder: 'Sen asignar',
    employeeNone: 'Sen empregado',
    employeeFilterAll: 'Todos os empregados',
    employeeCardTitle: 'Empregado asignado',
  },
  team: {
    title: 'Equipo',
    addEmployee: 'Engadir empregado',
    intro: 'Xestiona os empregados da túa empresa. Asígnaos a reservas para que reciban os detalles por email, ou actívaos para que fagan as súas propias reservas a cargo da empresa.',
    featureRosterTitle: 'Cadro de persoal',
    featureRosterDesc: 'Nome, email, teléfono e NIF de cada empregado. A maioría son recurrentes: reutilízanse en cada reserva.',
    featureEmailTitle: 'Detalles por email',
    featureEmailDesc: 'Ao reservar, asigna o empregado e recibe os datos do aloxamento por correo.',
    featureActivateTitle: 'Activar para reservar',
    featureActivateDesc: 'Activa un empregado para que entre co seu email e reserve a cargo da empresa.',
    empty: 'Aínda non hai empregados. En breve poderás engadilos e asignalos ás túas reservas.',
    editEmployee: 'Editar empregado',
    editDesc: 'Modifica os datos de contacto do empregado.',
    addDesc: 'Engade un empregado e actívao para que entre co seu propio email.',
    addNote: 'Engadirase á ficha de empregados. Para que entre co seu correo, activa o seu acceso despois.',
    activateLogin: 'Activar acceso',
    alreadyActivated: 'Este empregado xa ten o acceso activado.',
    platformUnavailable: 'O servizo non está dispoñible agora. Téntao máis tarde.',
    phone: 'Teléfono',
    updated: 'Empregado actualizado.',
    added: 'Empregado engadido.',
    emailExists: 'Xa existe un empregado con ese email.',
    activated: 'Empregado activado.',
    deactivated: 'Empregado desactivado.',
    deleted: 'Empregado eliminado.',
    activate: 'Activar',
    deactivate: 'Desactivar',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar empregado',
    deleteConfirm: 'Seguro que queres eliminar {{name}}? Borrarase a súa conta e non se poderá desfacer.',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    statusRoster: 'Só ficha',
    tempPwTitle: 'Contrasinal temporal',
    tempPwDesc: 'Este é o contrasinal temporal de {{name}}. Compárteo coa persoa de forma segura.',
    tempPwWarn: 'Non se volverá mostrar. Cópiao agora.',
    copy: 'Copiar',
    copied: 'Copiado',
  },
  agency: {
    title: 'Clientes',
    intro: 'Xestiona as empresas cliente da túa axencia. Engádeas co seu email de facturación e reserva viaxes ao seu nome: a factura vai á empresa cliente.',
    addClient: 'Engadir empresa cliente',
    clientEmail: 'Email de facturación da empresa',
    clientEmailPlaceholder: 'facturas@empresa.es',
    addNote: 'A empresa debe ter conta en bitutravel e estar aprobada. Validarase ao vincularla.',
    empty: 'Aínda non tes empresas cliente. Engádeas para comezar a reservar ao seu nome.',
    client: 'Cliente',
    unknownClient: 'Empresa cliente',
    unlinkConfirm: 'Seguro que queres desvincular {{name}}? Xa non poderás reservar ao seu nome.',
    unlinkedBtn: 'Desvincular',
    unlinked: 'Empresa cliente desvinculada.',
    linked: 'Empresa cliente vinculada: {{name}}.',
    notFound: 'Non se atopou ningunha empresa aprobada con ese email.',
    billTo: 'Reservar para',
    selectClient: 'Selecciona unha empresa cliente',
    noClientsWarn: 'Engade primeiro unha empresa cliente en Clientes para poder reservar.',
  },

  invoices: {
    title: 'Facturas e partes',
    backToBookings: '← As miñas reservas',
    count: 'Facturas',
    baseTotal: 'Base impoñible',
    ivaTotal: 'IVE',
    irpfTotal: 'IRPF retido',
    total: 'Total facturado',
    invoicesTitle: 'Facturas',
    ref: 'Reserva',
    parteTitle: 'Partes de viaxeiro',
    parteEmpty: 'Aínda non hai partes de viaxeiro.',
    empty: 'Aínda non tes facturas. Xéranse automaticamente ao confirmar unha reserva.',
    regenTitle: 'Reemitir documentos',
    regenDesc: 'Rexenera a factura e o parte de viaxeiro dunha reserva (útil para a contabilidade).',
    regenDone: 'Documentos rexenerados.',
    regenError: 'Non se puideron rexenerar os documentos.',
    downloadError: 'Non se puido descargar o documento.',
    navInvoices: 'Facturas',
    period30: 'Últimos 30 días',
    period90: 'Últimos 90 días',
    period365: 'Últimos 12 meses',
    periodAll: 'Todo o histórico',
    periodEmpty: 'Non hai facturas neste período.',
    exportCsv: 'Exportar CSV',
    exportZip: 'Descargar PDF (ZIP)',
    statusIssued: 'Emitida',
    statusPaid: 'Pagada',
    statusVoid: 'Anulada',
  },
  owner: {
    calendar: {
      title: 'Calendario de tarifas',
      subtitle: 'Prezo, estancia mínima e dispoñibilidade noite a noite',
      navButton: 'Tarifas',
      backendRequired: 'Configura o backend de Supabase para usar o calendario de tarifas.',
      basePrice: 'Tarifa base',
      cleaningFee: 'Limpeza',
      applyTitle: 'Aplicar á selección',
      clearSelection: 'Quitar a selección',
      selectHint: 'Fai clic nunha noite e despois noutra para escoller un rango. Cada cela é unha noite: a última marcada é a noite anterior á saída.',
      selectedNights: '{{count}} noite seleccionada | {{count}} noites seleccionadas',
      skipped: '{{count}} noite omitida (reservada ou pasada) | {{count}} noites omitidas (reservadas ou pasadas)',
      noneEditable: 'Todas as noites seleccionadas están reservadas ou xa pasaron.',
      priceLabel: 'Novo prezo (€)',
      pricePlaceholder: '€ / noite',
      minNightsLabel: 'Estancia mínima (noites)',
      minNightsPlaceholder: 'p. ex. 5',
      applyPrice: 'Fixar prezo',
      applyMinNights: 'Fixar mínima',
      block: 'Bloquear',
      unblock: 'Abrir',
      removeOverride: 'Quitar a personalización',
      blockNameLabel: 'Nome do bloqueo',
      blockNamePlaceholder: 'p. ex. Mantemento, Obra…',
      saved: 'Calendario actualizado',
      saveError: 'Non se puido gardar o calendario.',
      legend: {
        available: 'Dispoñible',
        priced: 'Prezo personalizado',
        blocked: 'Bloqueada',
        booked: 'Reservada',
        past: 'Pasada',
        sunday: 'Domingo',
      },
      ical: {
        title: 'Exportar calendario (iCal)',
        desc: 'Conecta este feed con Airbnb, Booking.com ou o teu channel manager para sincronizar as reservas.',
        copy: 'Copiar',
        copied: 'Enlace copiado',
        unavailable: 'Feed non dispoñible para esta propiedade.',
      },
      bulk: {
        from: 'Dende',
        to: 'ata',
        allDays: 'Todos os días',
        weekdays: 'Entre semana',
        weekends: 'Fin de semana',
        allYear: 'Todo o ano',
        pickDay: 'Escolle polo menos un día da semana',
      },
    },
    revenueTitle: 'Ingresos',
    invoicesTitle: 'Facturas e cobros',
    invoicesNote: 'As facturas xéranse automaticamente ao confirmar unha reserva; os pagamentos liquídanse segundo o calendario bitutravel.',
    gross: 'Base (sen IVE)',
    fee: 'Comisión de bitutravel',
    iva: 'IVE',
    net: 'Ingreso neto',
    paidOut: 'Pagado',
    pending: 'Pendente de pagamento',
    monthlyTitle: 'Ingresos por mes',
    perPropertyTitle: 'Por propiedade',
    property: 'Propiedade',
    bookings: 'Reservas',
    nights: 'Noites',
    payoutsTitle: 'Pagamentos ao propietario',
    eligibleDesc: 'Reservas confirmadas listas para pagar:',
    payNow: 'Pagar',
    scheduled: 'Programado',
    noPayouts: 'Aínda non hai pagamentos.',
    noData: 'Sen datos aínda.',
    payoutDone: 'Pagamento emitido.',
    payoutError: 'Non se puido emitir o pagamento.',
    range7: '7 d',
    range15: '15 d',
    range30: '30 d',
    range90: '90 d',
    range12m: '12 m',
    rangeAll: 'Todo',
    payoutConfirmTitle: 'Confirmar pagamento',
    payoutConfirmDesc: 'Emitir o pagamento da reserva #{{id}} por {{amount}}?',
    confirm: 'Confirmar',
    propertiesNav: 'Calendario',
    propertiesTitle: 'Calendario',
    newProperty: 'Engadir propiedade',
    editProperty: 'Editar',
    propertyUntitled: 'Propiedade sen título',
    propertiesEmpty: 'Aínda non publicaches ningunha propiedade.',
    pendingReviewNote: 'As propiedades novas quedan en revisión até que o equipo de bitutravel as aprobe. Avisarémoste por correo.',
    pendingEditorNote: 'Esta propiedade está en revisión. Poderás editala; aparecerá na busca cando sexa aprobada.',
    unpublished: 'Non publicada',
    photoCount: '{{count}} fotos',
    noPhotos: 'Sen fotos',
    unitCount: '{{count}} unidades',
    viewCalendar: 'Calendario',
    viewList: 'Lista',
    searchUnits: 'Buscar unidades…',
    sortName: 'Nome',
    sortRecent: 'Recentes',
    chipNeedsPhotos: 'Sen fotos',
    stripNoBookings: 'Sen reservas nos próximos 30 días',
    pms: {
      title: 'Xestor de reservas',
      subtitle: 'Reservas por unidade — arrastra para mover',
      prev: 'Anterior',
      next: 'Seguinte',
      today: 'Hoxe',
      view_month: 'Mes',
      view_week: 'Semana',
      dragHint: 'Arrastra unha reserva a outra unidade ou data para movela.',
      moved: 'Reserva movida',
      moveError: 'Non se puido mover a reserva',
      noCity: 'Sen cidade',
      cities: 'Cidades',
      properties: 'Propiedades',
      unit: 'Unidade',
      overall: 'Vista xeral',
      allProperties: 'Todas as propiedades',
      noUnits: 'Aínda non tes unidades. Engade unha propiedade para comezar.',
      guest: 'Hóspede',
      dragHintBlocked: "Haz clic en un día vacío para bloquearlo / abrirlo. Arrastra una reserva para moverla; arrastra su borde derecho para ampliar o acortar.",
      addBooking: "Añadir reserva",
      dates: 'Datas',
      autoRate: 'Tarifa automática',
      applyCustomPrice: 'Aplicar prezo personalizado (desconto)',
      customPriceHint: 'Edita o total para aplicar un desconto. Repártese entre as noites.',
      manualBooking: "Reserva manual",
      manualBadge: "Manual",
      guestName: "Nombre del huésped",
      guestNif: "NIF del huésped",
      guests: "Huéspedes",
      pricePerNight: "Prezo por noite",
      checkin: "Entrada",
      checkout: "Salida",
      block: "Bloquear",
      unblock: "Abrir",
      blocked: "Bloqueado",
      blockTitle: 'Bloquear noite',
      blockNameLabel: 'Nome (opcional)',
      blockNamePlaceholder: 'p. ex. Mantemento',
      blockNameHint: 'Mostrarase no día bloqueado.',
      blockConfirm: 'Bloquear',
      manualCreated: "Reserva manual creada",
      manualError: "No se pudo crear la reserva manual",
      notAvailable: "No disponible para esas fechas",
      belowMinStay: "Por debajo de la estancia mínima de esta unidad",
      detail: "Detalle de la reserva",
      property: "Propiedad",
      nights: "Noches",
      total: "Total",
      iva: "IVA",
      fee: "Comisión de la plataforma",
      payout: "Pago",
      channel: "Canal",
      status: "Estado",
      statusConfirmed: "Confirmada",
      statusActive: "En estancia",
      statusPending: "Pendiente",
      statusAwaiting: "Pendiente de pago",
      statusCancelled: "Cancelada",
      channelManual: "Manual",
      channelDirect: "Directo",
      channelIcal: "iCal (importado)",
      icalNoPayout: "Bloqueo externo — sen pagamento",
      confirmMove: "Confirmar movimiento",
      moveFrom: "Desde",
      moveTo: "Hasta",
      moveNote: "La disponibilidad y el precio se revalidan al confirmar.",
      confirm: "Confirmar",
      extendTitle: "Ampliar estancia",
      shortenTitle: "Acortar estancia",
      newCheckout: "Nueva salida",
      extended: "Estancia actualizada",
      extendError: "No se pudo actualizar la estancia",
    },
    products: {
      nav: 'Propiedades',
      title: 'Propiedades',
      subtitle: 'Tarifas e canais por unidade. A tarifa predeterminada sincronízase co prezo da propiedade.',
      empty: 'Aínda non tes propiedades.',
      ratePlans: 'Tarifas',
      addRatePlan: 'Engadir tarifa',
      editRatePlan: 'Editar tarifa',
      ratePlanDesc: 'Unha tarifa é unha oferta vendible desta unidade (prezo, limpeza, estancia mínima).',
      noPlans: 'Sen tarifas aínda.',
      planCount: '{{count}} tarifas',
      icalCount: '{{count}} iCal',
      default: 'Predeterminada',
      inactive: 'Inactiva',
      minNights: 'mín. {{count}} noites',
      minNightsLabel: 'Noites mínimas',
      feePct: 'comisión {{pct}}%',
      feePctLabel: 'Comisión bitutravel (%)',
      feePctPlaceholder: 'predeterminada',
      feePctHint: 'Baleiro = comisión global. 0 = cliente propio (sen comisión).',
      makeDefault: 'Tarifa predeterminada',
      name: 'Nome',
      basePrice: 'Prezo base (NET)',
      cleaningFee: 'Limpeza',
      cancellation: 'Cancelación',
      policy: {
        flexible: 'Flexible',
        moderate: 'Moderada',
        strict: 'Estrita',
      },
      save: 'Gardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      confirmDelete: 'Eliminar?',
      defaultNoDelete: 'Non se pode eliminar a tarifa predeterminada.',
      created: 'Tarifa creada.',
      updated: 'Tarifa actualizada.',
      deleted: 'Tarifa eliminada.',
      channels: 'Canais',
      addChannel: 'Engadir canal',
      direct: 'Directo',
      noConnections: 'Sen conexións. Engade unha canle iCal para importar un calendario externo.',
      icalChannel: 'iCal',
      addIcal: 'Engadir conexión iCal',
      icalDesc: 'Pega a URL iCal dun calendario externo (Airbnb, Booking, Google…). As datas reservadas bloquearán esta unidade.',
      icalUrl: 'URL do calendario iCal',
      addAndSync: 'Engadir e sincronizar',
      syncNow: 'Sincronizar',
      syncAll: 'Sincronizar todo',
      syncDone: '{{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflitos',
      syncAllDone: 'Sincronización completa: {{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflitos',
      syncError: 'Erro de sincronización',
      lastSync: 'Última sincronización',
      neverSynced: 'Sen sincronizar aínda',
      connectionDeleted: 'Conexión eliminada.',
      connStatus: {
        pending: 'Pendente',
        active: 'Activa',
        paused: 'Pausada',
        error: 'Erro',
      },
      rangeActionTitle: 'Rango seleccionado',
      rangeActionHint: 'Que queres facer con estas noites?',
      selectHint: 'Preme nunha noite e despois noutra (ou dúas veces na mesma) para escoller un rango.',
    },

    status: {
      pending: 'En revisión',
      approved: 'Publicado',
      rejected: 'Rexeitada',
    },
    step1: 'Datos',
    step2: 'Descrición',
    step3: 'Localización e fotos',
    backStep: 'Atrás',
    nextStep: 'Seguinte',
    saveProperty: 'Gardar a propiedade',
    fieldType: 'Tipo de aloxamento',
    type: {
      apartment: 'Apartamento',
      studio: 'Estudio',
      house: 'Casa',
      room: 'Dormitorio',
      loft: 'Loft',
      duplex: 'Dúplex',
      cabin: 'Cabaña',
      guesthouse: 'Casa de hóspedes',
      hotel: 'Hotel',
      bed_breakfast: 'Casa rural',
    },
    fieldCapacity: 'Capacidade (hóspedes)',
    fieldBeds: 'Camas',
    fieldPrice: 'Prezo por noite (€)',
    fieldCleaning: 'Tarifa de limpeza (€)',
    fieldCheckinTime: 'Hora de entrada',
    fieldCheckoutTime: 'Hora de saída',
    fieldTitleEs: 'Título (castelán)',
    fieldTitleEn: 'Título (inglés)',
    fieldDescEs: 'Descrición (castelán)',
    fieldDescEn: 'Descrición (inglés)',
    fieldCity: 'Cidade',
    fieldCategory: 'Categoría',
    fieldCategoryHint: 'executiva, estándar, suite…',
    fieldBuilding: 'Edificio / enderezo',
    fieldUnitLabel: 'Etiqueta da unidade',
    fieldNeighborhood: 'Barrio / distrito',
    fieldNeighborhoodHint: 'ex. Chamberí',
    fieldPostalCode: 'Código postal',
    cityPrefillNote: 'Ao escoller a cidade, enchemos as coordenadas co centro; axústaas se coñeces a localización exacta.',
    photosAfterCreate: 'Garda a propiedade para poder engadir fotos.',
    addPhotos: 'Engadir fotos',
    deletePhoto: 'Eliminar foto',
    photoUploadError: 'Non se puido subir a foto.',
    photoDeleteError: 'Non se puido eliminar a foto.',
    createdToast: 'Propiedade creada. Está en revisión.',
    savedToast: 'Propiedade gardada.',
    saveError: 'Non se puido gardar a propiedade.',
    fiscal: {
      title: 'Datos fiscais e VeriFactu',
      subtitle: 'Información do emisor e autorización para que bitutravel remita as túas facturas á AEAT.',
      statusActive: 'VeriFactu activo. As túas facturas de aloxamento rémitense á AEAT.',
      statusPending: 'VeriFactu pendente. As túas facturas emítense pero non se remiten á AEAT.',
      statusRevoked: 'A túa autorización foi revogada. A remisión á AEAT está pausada.',
      active: 'Activo',
      pending: 'Pendente',
      revoked: 'Revogado',
      issuerTitle: 'Datos do emisor',
      personaType: 'Tipo de persoa',
      personaF: 'Física',
      personaJ: 'Xurídica',
      seriesLodging: 'Serie de facturas',
      seriesHint: 'Serie AEAT para as túas facturas de aloxamento (por defecto O). Non a cambies sen motivo.',
      legalName: 'Razón social / Nome',
      nif: 'NIF',
      country: 'País',
      street: 'Enderezo',
      postalCode: 'Código postal',
      city: 'Poboación',
      save: 'Gardar datos fiscais',
      saved: 'Datos fiscais gardados.',
      saveError: 'Non se puideron gardar os datos fiscais.',
      errFields: 'A razón social e o NIF son obrigatorios.',
      apoderamientoTitle: 'Apoderamento',
      apoderamientoDesc: 'Para remitir facturas á AEAT no teu nome, bitutravel precisa un poder de representación asinado. Sube o poder asinado para activar a remisión.',
      poderOnFile: 'Poder rexistrado:',
      uploadPoder: 'Subir poder asinado (PDF)',
      poderHint: 'PDF, máx. 10 MB.',
      granted: 'Apoderamento activado. VeriFactu remitirá as túas próximas facturas.',
      grantError: 'Non se puido rexistrar o poder.',
      errPoderSize: 'O ficheiro supera os 10 MB.',
      legalNote: 'Ao subir o poder confirmas que asinaches a autorización de representación para que bitutravel remita facturas á AEAT (RD 1007/2023).',
      bannerPending: 'Activa VeriFactu para remitir as túas facturas á AEAT.',
      bannerRevoked: 'A túa autorización VeriFactu está revogada.',
      bannerCta: 'Configurar',
    },

  },
  profile: {
    title: 'Perfil e axustes',
    navProfile: 'Perfil',
    accountSection: 'Conta',
    statusLabel: 'Estado da conta',
    rejectionReason: 'Motivo da rexeición',
    detailsSection: 'Datos fiscais',
    languageSection: 'Idioma',
    localeLabel: 'Idioma preferido',
    localeHint: 'Gárdase na túa conta e aplícase en todos os teus dispositivos.',
    localeSaved: 'Idioma actualizado.',
    billingSection: 'Facturación e pago',
    invoiceEmail: 'Email de facturación',
    invoiceEmailPlaceholder: 'facturas@tuempresa.es',
    ibanTransfer: 'IBAN (pago por transferencia)',
    ibanHint: 'Se prefires pagar por transferencia bancaria.',
    preferredMethod: 'Método de pago preferido',
    methodCard: 'Tarxeta',
    methodTransfer: 'Transferencia',
    savedCards: 'Tarxetas gardadas',
    defaultCard: 'Predeterminada',
    billingProcessorNote: 'Os datos da tarxeta tokenízanse con Revolut; nunca almacenamos o número completo.',
    billingSaved: 'Facturación actualizada.',
  },
  auth: {
    registerTitle: 'Crear conta',
    loginTitle: 'Iniciar sesión',
    rolePrompt: 'Como vas usar bitutravel?',
    roleBook: 'Reservo estancias',
    roleList: 'Publico propiedades',
    roleCompany: 'Empresa',
    roleAutonomo: 'Autónomo',
    roleOwner: 'Propietario',
    roleEmployeeLabel: 'Empregado',
    roleAgencyLabel: 'Axencia',
    roleCompanyDesc: 'Reservas centralizadas para a vosa empresa',
    roleAutonomoDesc: 'Para profesionais autónomos',
    roleOwnerDesc: 'Para publicar e monetizar as túas propiedades',
    roleBookerPrompt: 'Quen reserva?',
    pathManager: 'Xestiono propiedades',
    pathManagerDesc: 'Publica o teu inventario e xestiona tarifas e dispoñibilidade',
    pathBook: 'Reservo estancias',
    pathBookDesc: 'Para empresas, empregados e autónomos que se aloxan',
    roleEmployee: 'Traballo nunha empresa',
    roleEmployeeDesc: 'Reservo coa tarxeta da miña empresa; a factura vai para ela',
    contactName: 'Persoa de contacto',
    email: 'Correo electrónico',
    fullName: 'Nome completo',
    legalName: 'Razón social',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Enderezo',
    iban: 'IBAN para cobros',
    irpf: 'Retención IRPF (%)',
    submit: 'Enviar solicitude',
    pendingTitle: 'Solicitude en revisión',
    pendingDesc: 'O noso equipo está a verificar a túa conta. Avisarémoste por correo cando sexa aprobada.',
    pendingApproved: 'A túa conta foi aprobada!',
    checkStatus: 'Comprobar de novo',
    profileErrorTitle: 'Non pudemos cargar o teu perfil',
    profileErrorDesc:
      'A túa sesión é válida, pero non atopamos os datos da túa conta. Téntao de novo ou pecha a sesión.',
    rejectedTitle: 'Solicitude rexeitada',
    rejectedDesc: 'A túa solicitude non foi aprobada. Motivo: {{reason}}',
    loginPrompt: 'Xa tes conta? Inicia sesión',
    registerPrompt: 'Non tes conta? Rexístrate',
    login: 'Iniciar sesión',
    magicLink: 'Enviar o enlace máxico',
    magicLinkSent:
      'Enviamosche un enlace máxico ao teu correo. Ábreo para iniciar sesión.',
    cifInvalid: 'CIF non válido',
    cifInRegistry: 'Atopada no directorio',
    nifOrCifInvalid: 'NIF/CIF non válido',
    ibanInvalid: 'IBAN non válido',
    irpfRange: 'Debe estar entre 7 e 45 %',
    loginErrorGeneric: 'Non se puido iniciar sesión. Revisa o correo.',
    loginRateLimited: 'Demasiados intentos. Espera un minuto.',
    loginEmailNotConfirmed: 'Confirma o teu correo antes de iniciar sesión.',
  },
  admin: {
    approvalsTitle: 'Cola de aprobacións',
    approve: 'Aprobar',
    reject: 'Rexeitar',
    reason: 'Motivo',
    empty: 'Non hai solicitudes pendentes',
    typeCompany: 'Empresa',
    typeAutonomo: 'Autónomo',
    typeOwner: 'Propietario',
    approvedToast: 'Solicitude aprobada',
    rejectedToast: 'Solicitude rexeitada',
    decisionFailed: 'Non se puido gardar a decisión',
    searchPlaceholder: 'Buscar por nome, correo ou NIF/CIF',
    tabAll: 'Todas',
    tabCompany: 'Empresas',
    tabAutonomo: 'Autónomos',
    tabOwner: 'Propietarios',
    confirmApprove: 'Aprobar a {{name}}?',
    confirmReject: 'Rexeitar a {{name}}?',
    confirm: 'Confirmar',
    reasonRequired: 'Indica o motivo da rexeición',
    noMatches: 'Sen resultados',
    roleAdmin: 'Administración',
    consoleTitle: 'Consola de administración',
    navApprovals: 'Aprobacións',
    navAccounts: 'Contas',
    navBookings: 'Reservas',
    navInvoices: 'Facturas',
    tabAgency: 'Axencias',
    tabEmployee: 'Empregados',
    tabBlocked: 'Bloqueados',
    typeAgency: 'Axencia',
    typeEmployee: 'Empregado',
    typeAdmin: 'Administrador',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Pendente',
    active: 'Activo',
    blocked: 'Bloqueado',
    rejected: 'Rexeitado',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    blockedToast: 'Conta bloqueada',
    unblockedToast: 'Conta desbloqueada',
    manageFailed: 'Non se puido cambiar o estado da conta',
    commissionDefault: 'Por defecto {{pct}}%',
    commissionEdit: 'Editar',
    commissionSave: 'Gardar',
    commissionCancel: 'Cancelar',
    commissionSaved: 'Comisión actualizada.',
    commissionFailed: 'Non se puido actualizar a comisión.',
    lastActions: '{{count}} accións de administración rexistradas',
    noBookings: 'Non hai reservas.',
    noInvoices: 'Non hai facturas.',
    kindCommission: 'Comisión',
    kindLodging: 'Aloxamento',
    vfFiled: 'VeriFactu remitida',
    vfIncidence: 'Incidencia',
    vfPending: 'VeriFactu pendente',
    navRegistry: 'Directorio',
    vfSubmit: 'Enviar a AEAT',
    vfSubmitted: 'Enviada a AEAT',
    vfSubmitFailed: 'Non se puido enviar a AEAT',
    vfNotConfigured: 'Certificado VeriFactu non configurado',
    void: 'Anular',
    voidConfirm: 'Anular esta factura? Se foi enviada a AEAT, enviarase unha anulación.',
    voidDone: 'Factura anulada',
    voidFailed: 'Non se puido anular a factura',
    voidAnulacionPending: 'Anulación AEAT pendente de certificado',
    voided: 'Anulada',
    rect: 'Rectificativa',
    rectConfirm: 'Emitir unha rectificativa que substitúa esta factura?',
    rectDone: 'Rectificativa emitida',
    rectFailed: 'Non se puido emitir a rectificativa',
    registry: {
      addTitle: 'Engadir empresa',
      editTitle: 'Editar empresa',
      listTitle: 'Directorio de empresas',
      cif: 'CIF',
      legalName: 'Razón social',
      street: 'Rúa',
      postalCode: 'Código postal',
      city: 'Cidade',
      province: 'Provincia',
      country: 'País',
      save: 'Gardar',
      saved: 'Empresa gardada',
      saveError: 'Non se puido gardar a empresa',
      deleted: 'Empresa eliminada',
      deleteError: 'Non se puido eliminar a empresa',
      errFields: 'O CIF e a razón social son obrigatorios',
      empty: 'Aínda non hai empresas no directorio',
      edit: 'Editar',
    },
  },
  dashboard: {
    roleLabel: 'Rol',
    emailLabel: 'Correo',
  },
  notFound: {
    title: 'Páxina non atopada',
    desc: 'A páxina que buscas non existe ou cambiou de enderezo.',
  },
  error: {
    boundaryDesc: 'Algo saíu mal. Recarga para continuar.',
    boundaryReload: 'Recargar',
  },
  common: {
    loading: 'Cargando…',
    error: 'Algo saíu mal',
    favorite: 'Gardar en favoritos',
    required: 'Obrigatorio',
    back: 'Volver',
    retry: 'Reintentar',
    continue: 'Continuar',
    done: 'Feito',
    save: 'Gardar',
    plusIva: '+ IVE',
    cancel: 'Cancelar',
    rooms: 'habitacións',
    room: 'habitación',
    bathrooms: 'baños',
    bathroom: 'baño',
    increment: 'Aumentar',
    decrement: 'Reducir',
    edit: 'Editar',
    close: "Pechar",
    previous: 'Anterior',
    next: 'Seguinte',
  },
  amenities: {
    wifi: 'Wifi',
    parking: 'Aparcamento',
    ac: 'Aire acondicionado',
    heating: 'Calefacción',
    washing: 'Lavadora',
    dishwasher: 'Lavavajillas',
    elevator: 'Ascensor',
    furnished: 'Moblado',
    kitchen: 'Cociña',
    meeting_room: 'Sala de reunións',
    printer: 'Impresora',
    gym: 'Ximnasio',
  },
} as const